import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const Container = ({ children, className = "" }) => (
  <div className={`max-w-[1240px] mx-auto px-5 lg:px-8 ${className}`}>{children}</div>
);

export const Eyebrow = ({ children, testId }) => (
  <span className="eyebrow" data-testid={testId}>{children}</span>
);

export const SectionHeading = ({ eyebrow, title, intro, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="mt-3 text-3xl md:text-4xl font-display font-semibold text-white leading-tight">{title}</h2>
    {intro && <p className="mt-4 text-base md:text-lg text-cool-light leading-relaxed">{intro}</p>}
  </div>
);

export const CTAButton = ({ to, children, variant = "primary", testId, onClick, external = false }) => {
  const base = "inline-flex items-center gap-2 text-sm font-semibold px-5 py-3 rounded-sm transition-colors duration-200";
  const styles = {
    primary: "bg-cyan text-nb-deep hover:bg-white",
    secondary: "border border-cool-mid text-white hover:border-cyan hover:text-cyan",
    gold: "bg-gold text-nb-deep hover:bg-white",
  };
  const cls = `${base} ${styles[variant]}`;
  if (onClick) return <button onClick={onClick} className={cls} data-testid={testId}>{children}<ArrowRight size={16} /></button>;
  if (external) return <a href={to} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId}>{children}<ArrowRight size={16} /></a>;
  return <Link to={to} className={cls} data-testid={testId}>{children}<ArrowRight size={16} /></Link>;
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.5, delay }}
    className={className}
  >
    {children}
  </motion.div>
);
